var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 30,
    viewBox: "0 0 151 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9754 4.52502C37.9754 4.60002 45.3278 23.7 46.0655 25.475H41.3688L39.6967 21.2H31.4098L29.8115 25.475H25.1147L33.1557 4.52502H37.9754ZM38.0246 16.775L35.541 10.45L33.1311 16.775H38.0246Z",
    fill: "#11142D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9999 25.475H62.59L57.5491 18.55H53.3442V25.475H48.9917V4.52502H61.1146C64.8523 4.52502 67.9999 7.72503 67.9999 11.525C67.9999 14.8 65.7868 17.575 62.7868 18.325L67.9999 25.475ZM61.1146 14.175C62.5163 14.175 63.6474 12.95 63.6474 11.525C63.6474 10.1 62.5163 8.95003 61.1146 8.95003H53.3442V14.2H61.1146V14.175Z",
    fill: "#11142D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6885 25.475V4.52502H75.9672V25.475H71.6885Z",
    fill: "#11142D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8276 4.52502H97.9506V9.97503L85.3112 21.125H97.9506V25.475H79.8276V20.1L92.467 8.95003H79.8276V4.52502Z",
    fill: "#11142D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.812 4.52502L112.361 12.15L116.91 4.52502H122.934V25.475H118.656V10.1L114.918 16.35L113.246 19.075H111.5L109.828 16.35L106.09 10.1V25.475H101.812V4.52502H107.812Z",
    fill: "#11142D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.721 4.52502C138.721 4.60002 146.074 23.7 146.812 25.475H142.115L140.443 21.2H132.156L130.558 25.475H125.861L133.902 4.52502H138.721ZM138.771 16.775L136.287 10.45L133.877 16.775H138.771Z",
    fill: "#11142D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1237_44642",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 9,
    height: 10
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18848 4.52502H12.1065L4.18848 13.85V4.52502Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1237_44642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3358 4.42505H-2.40186V25.5251H13.3358V4.42505Z",
    fill: "url(#paint0_linear_1237_44642)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.123 4.52502H17.4427L8.54102 15L17.4427 25.475H23.123L14.2951 15L23.123 4.52502Z",
    fill: "#11142D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1237_44642",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 16,
    width: 9,
    height: 10
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18848 25.475H12.1065L4.18848 16.15V25.475Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1237_44642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3358 4.42505H-2.40186V25.5251H13.3358V4.42505Z",
    fill: "url(#paint1_linear_1237_44642)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1237_44642",
    x1: 5.46141,
    y1: 4.4151,
    x2: 5.46141,
    y2: 25.5194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#42FFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#8826FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1237_44642",
    x1: 5.46141,
    y1: 4.4151,
    x2: 5.46141,
    y2: 25.5194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#42FFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#8826FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5151f0e5ecc86b1a2cd5d97ae6f93319.svg";
export { ForwardRef as ReactComponent };